import React, { useEffect, useRef } from 'react';
import { Redirect } from 'react-router-dom';
import useBloqueio from 'hooks/useBloqueio';
import { entradaAlteracaoPlanoBloqueada } from 'utils/bloqueios';
import { ModalInformativo } from 'components/Modais/ModalInformativo';
import { FuncionalidadePortalCliente } from 'constants/funcionalidadePortalCliente';
import CriarUsuariosV2 from 'EstruturaAntiga/pages/usuariosV2/novo/index.jsx';
import CadastroMultiplosUsuarios from 'pages/Usuarios/CadastroMultiplos';
import RestaurarUsuario from 'pages/Usuarios/Restaurar';
import AlterarPlanoV2 from 'EstruturaAntiga/pages/usuariosV2/alterarPlano/index.jsx';

const comBloqueio = (funcionalidade, { redirect, titulo, deveBloquear }) => (Componente) => {
  const ComponenteComBloqueio = (props) => {
    const estado = useBloqueio(funcionalidade);
    const { carregando, mensagem } = estado;
    const bloquearEntrada = (deveBloquear ?? (({ bloqueado }) => bloqueado))(estado);
    const jaAlertou = useRef(false);

    useEffect(() => {
      if (!carregando && bloquearEntrada && !jaAlertou.current) {
        jaAlertou.current = true;
        ModalInformativo(titulo, mensagem);
      }
    }, [carregando, bloquearEntrada, mensagem, titulo]);

    if (!carregando && bloquearEntrada) return <Redirect to={redirect} />;

    return <Componente {...props} />;
  };

  return ComponenteComBloqueio;
};

export default comBloqueio;

export const CriarUsuariosV2ComBloqueio = comBloqueio(FuncionalidadePortalCliente.CriacaoUsuario, {
  redirect: '/usuarios',
  titulo: 'Criação de usuários indisponível',
})(CriarUsuariosV2);

export const CadastroMultiplosUsuariosComBloqueio = comBloqueio(FuncionalidadePortalCliente.CriacaoUsuario, {
  redirect: '/usuarios',
  titulo: 'Criação de usuários indisponível',
})(CadastroMultiplosUsuarios);

export const RestaurarUsuarioComBloqueio = comBloqueio(FuncionalidadePortalCliente.RestauracaoUsuario, {
  redirect: '/usuarios-excluidos',
  titulo: 'Restauração de usuários indisponível',
})(RestaurarUsuario);

export const AlterarPlanoV2ComBloqueio = comBloqueio(FuncionalidadePortalCliente.AlteracaoPlanoUsuario, {
  redirect: '/usuarios',
  titulo: 'Alteração de plano indisponível',
  deveBloquear: entradaAlteracaoPlanoBloqueada,
})(AlterarPlanoV2);
